import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M3.78879 9.03673C3.0814 9.41965 1.22668 10.2015 2.35633 11.1799C2.90815 11.6578 3.52275 11.9996 4.29543 11.9996H8.70457C9.47725 11.9996 10.0918 11.6578 10.6437 11.1799C11.7733 10.2015 9.9186 9.41965 9.21121 9.03673C7.55241 8.1388 5.44759 8.1388 3.78879 9.03673Z"
        stroke="#72808F" strokeWidth="1.25" />
      <path
        d="M8.75 4.27273C8.75 5.52792 7.74264 6.54545 6.5 6.54545C5.25736 6.54545 4.25 5.52792 4.25 4.27273C4.25 3.01753 5.25736 2 6.5 2C7.74264 2 8.75 3.01753 8.75 4.27273Z"
        stroke="#72808F" strokeWidth="1.25" />
      <path d="M4 15C4 18.3171 6.68286 21 10 21L9.14286 19.2857" stroke="#72808F" strokeWidth="1.25"
        strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20 9C20 5.68286 17.3171 3 14 3L14.8571 4.71429" stroke="#72808F" strokeWidth="1.25"
        strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M14.7888 19.0367C14.0814 19.4196 12.2267 20.2015 13.3563 21.1799C13.9082 21.6578 14.5227 21.9996 15.2954 21.9996H19.7046C20.4773 21.9996 21.0918 21.6578 21.6437 21.1799C22.7733 20.2015 20.9186 19.4196 20.2112 19.0367C18.5524 18.1388 16.4476 18.1388 14.7888 19.0367Z"
        stroke="#72808F" strokeWidth="1.25" />
      <path
        d="M19.75 14.2727C19.75 15.5279 18.7426 16.5455 17.5 16.5455C16.2574 16.5455 15.25 15.5279 15.25 14.2727C15.25 13.0175 16.2574 12 17.5 12C18.7426 12 19.75 13.0175 19.75 14.2727Z"
        stroke="#72808F" strokeWidth="1.25" />
    </svg>
  )
}

export default SvgComponent
